import FileList from './FileList';
import './FileList.scss';

export default FileList;
